import { SuspenseButton } from "@common/components/utility";
import { DiagnosisModel } from "@common/models";
import { makeBold } from "@common/utils";
import { observer } from "mobx-react";
import React from "react";
import classNames from 'classnames';
import { Button } from 'react-bootstrap';

/**
 * Props for PetProfileDiagnosesItem component.
 */
export type IPetProfileDiagnosesItemProps = {
  diagnosesRow: DiagnosisModel;
  query: string;
  style: React.CSSProperties;
  alreadyAdded: boolean;
  addDiagnosis: (diagnosis: DiagnosisModel) => void;
};

/**
 * Renders a searchable diagnoses row within the Pet Profile table.
 */
export const PetProfileDiagnosesItem = observer(
  ({
    diagnosesRow,
    query,
    style,
    alreadyAdded,
    addDiagnosis,
  }: IPetProfileDiagnosesItemProps) => {
    /**
     * Renders each row of the diagnoses list.
     * Includes:
     * - The diagnosis name (with query highlighting)
     * - An “Add” button (action to be implemented later)
     */
    return (
      <section className="pet-profile-diagnoses-section">
        <div
          role="row"
          style={style}
          className={classNames("pet-profile-diagnoses-item", (alreadyAdded) && "pet-profile-diagnoses-item-added", "d-flex", "d-flex-row", "align-items-center")}
        >
          <div
            role="cell"
            className="pet-profile-diagnoses-item-text flex-fill"
          >
            {makeBold(diagnosesRow.name, query)}
          </div>
          <div
            role="cell"
            className="d-flex justify-content-end"
            style={{ width: "14rem" }}
          >
            {alreadyAdded ? ( // has this diagnosis already been added to the visit?
              <Button
                className="pet-profile-diagnoses-item-added me-2"
                variant="outline-primary"
                style={{ width: "5rem" }}
                disabled
              >
                Added
              </Button>
            ) : (
              <SuspenseButton
                aria-label={`add ${diagnosesRow.name} to profile`}
                variant="outline-primary"
                style={{ width: "5rem" }}
                className="pet-profile-diagnoses-item-add me-2"
                onClick={() => addDiagnosis(diagnosesRow)}
              >
                Add
              </SuspenseButton>
            )}
          </div>
        </div>
      </section>
    );
  },
);
